import API from "../base.service";
import { ENDPOINT } from "../../constants.service";

const createShopper = async (data) => {
  return await API.postMethod(
    `${ENDPOINT.peoples.shopper.create}`,
    true,
    data,
    true
  );
};

const updateShopper = async (data) => {
  return await API.postMethod(
    `${ENDPOINT.peoples.shopper.update}`,
    true,
    data,
    true
  );
};

const shopperList = async (data) => {
  return await API.getMethod(
    `${ENDPOINT.peoples.shopper.list}`,
    true,
    true,
    data
  );
};
const deleteShopper = async (id) => {
  const url = `${ENDPOINT.peoples.shopper.delete}`.replace(":id", id);
  return await API.deleteMethod(url, true);
};
const getShopper = async (id) => {
  const url = `${ENDPOINT.peoples.shopper.show}`.replace(":id", id);
  return await API.getMethod(url, true);
};

const getShopperAccount = async (id) => {
  const url = `${ENDPOINT.peoples.shopper.accounts}`.replace(":id", id);
  return await API.getMethod(url, true);
};

const associateShopperAccounts = async (id, data) => {
  const url = `${ENDPOINT.peoples.shopper.associateAccountsApproval}`.replace(
    ":id",
    id
  );
  return await API.postMethod(url, true, data);
};

const associateShopperAccountsUpdate = async (id, data) => {
  const url = `${ENDPOINT.peoples.shopper.associateAccountsUpdate}`.replace(
    ":id",
    id
  );
  return await API.postMethod(url, true, data);
};

export default {
  getShopper,
  createShopper,
  updateShopper,
  shopperList,
  deleteShopper,
  getShopperAccount,
  associateShopperAccounts,
  associateShopperAccountsUpdate
};
